import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { preguntas } from '../data/faq';
export function Faq() {
  const [abierta, setAbierta] = useState<number | null>(0);
  return <section aria-labelledby="faq-titulo" className="w-full bg-canvas px-6 py-20" data-id="element-104" data-mp="1laza77h5z5cb">
      <div className="mx-auto max-w-3xl" data-id="element-105" data-mp="1gcxsapvh5c2f">
        <h2 id="faq-titulo" className="text-center font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-106" data-mp="1ge8uwmd6odry">
          Preguntas frecuentes
        </h2>

        <ul className="mt-12 space-y-3" data-id="element-107" data-mp="291mkfzejy721">
          {preguntas.map((item, index) => {
          const estaAbierta = abierta === index;
          return <li key={item.pregunta} className={`overflow-hidden rounded-2xl border bg-surface ${estaAbierta ? 'border-brand-300' : 'border-edge'}`} data-id="element-108" data-mp="240fd21gbn9vw" data-mpi={index}>
                <h3 data-id="element-109" data-mp="noa0sck4tqgf">
                  <button type="button" onClick={() => setAbierta(estaAbierta ? null : index)} aria-expanded={estaAbierta} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-brand-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-brand-600" data-id="element-110" data-mp="nnqszoo74ig4">
                    <span className="font-display text-base font-bold leading-snug text-ink" data-id="element-111" data-mp="6pvj448dudhj">
                      {index + 1} — {item.pregunta}
                    </span>
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-soft text-brand-700" data-id="element-112" data-mp="3szfzezqn7uh4">
                      {estaAbierta ? <MinusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-113" data-mp="3jy8ctexhoi2v" /> : <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-114" data-mp="3o03bebo1chcy" />}
                    </span>
                  </button>
                </h3>
                {estaAbierta && <div id={`faq-panel-${index}`} className="px-5 pb-5" data-id="element-115" data-mp="1ppuoknrllnmh">
                    <p className="text-sm leading-relaxed text-muted" data-id="element-116" data-mp="1kr1e747lycqj">{item.respuesta}</p>
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}